/**
 * The type to describe the media type of the Transceiver
 */
export const TRANSCEIVER_MEDIA_TYPES = ['audio', 'video'];
export const CAN_SET_STREAMS = typeof RTCRtpSender !== 'undefined' &&
    'setStreams' in RTCRtpSender.prototype;
//# sourceMappingURL=constants.js.map